var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"lock-overlay overflow-hidden"},[_vm._m(0),_c('q-icon',{staticStyle:{"margin":"auto"},attrs:{"name":"mdi-lock","size":"xl"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"premium-banner row"},[_c('span',{staticClass:"text-bold"},[_vm._v("Premium")])])
}]

export { render, staticRenderFns }